import React from 'react';
import styles from "./detail.module.scss";
import { formatNumberWithDot, imageLink } from '../../../hooks/utils';

const FlowDetail = ({item, onClose}) =>{

    const countryName = item.country;
    const flows2022 = item.netHNWIs2022Provisional > 0 ? "+ " + formatNumberWithDot(item.netHNWIs2022Provisional) : "- " + formatNumberWithDot(Math.abs(item.netHNWIs2022Provisional));
    const resident2022 = formatNumberWithDot(item.benchmarkingNoHNWIsCurrentlyInCountry);
    const percentage = item.benchmarkingPercentage > 0 ? "+ " + formatNumberWithDot(item.benchmarkingPercentage) + '%' : item.benchmarkingPercentage + '%' ;

    const urlText = item.urlText ? item.urlText : `Apply for residence in ${countryName}`;
    const url = item.url ? (<p className="mt-auto mb-0">{urlText} <a href={item.url} target="_blank" rel="noreferrer" className="text-underline">here</a></p>) : (<p className="mt-auto mb-0">&nbsp;</p>);
    
    const circleMark = item.category === "inflow" ? (<span className="circle circle-inflow"></span>) : (<span className="circle circle-outflow"></span>);

    return(
        <div className={`${styles.popup} ${styles.popupFlowCard} ${styles.card}`}>
        <button className={styles.closeButton} onClick={onClose}>
            <svg width="10px" height="9px" viewBox="0 0 10 9">
                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g transform="translate(-702.000000, -7.000000)" stroke="currentColor">
                        <g transform="translate(700.692388, 4.692388)">
                            <g transform="translate(6.500000, 6.500000) rotate(45.000000) translate(-6.500000, -6.500000) ">
                                <line x1="6.5" y1="1" x2="6.5" y2="12"></line>
                                <line x1="6.5" y1="1" x2="6.5" y2="11.5" transform="translate(6.500000, 6.250000) rotate(-90.000000) translate(-6.500000, -6.250000) "></line>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
        </button>
        <div className="row">
          <div className="col-md-3 col-lg-5">
          
            <div className="countryImageWrapper">
                 <img src={imageLink(countryName)} alt={countryName} />
            </div>
          </div>
          <div className="col-md-9 col-lg-7 d-flex flex-column justify-content-between pl-md-0">
            <h3 className={`mt-4 mt-md-0 mb-3 ${styles.countryName}`}>{circleMark} <span className={styles.countryNameText}>{item.country}</span></h3>

            <div className="row">
                <div className="col-4 d-flex flex-column justify-content-between">
                     <h5 className="field mb-0">2022 inflows/outflows (projected)</h5>
                     <h3 className={`mb-3 text-nowrap ${styles.value}`}>{flows2022}</h3>
                </div>
                <div className="col-4 d-flex flex-column justify-content-between">
                    <h5 className="field mb-0">Resident HNWIs in 2022</h5>
                    <h3 className={`mb-3 text-nowrap ${styles.value}`}>{resident2022}</h3>
                </div>
                <div className="col-4 d-flex flex-column justify-content-between">
                    <h5 className="field mb-0">% HNWIs gained/lost</h5>
                    <h3 className={`mb-3 text-nowrap ${styles.value}`}>{percentage}</h3>
                </div>
            </div>

            {url}
          </div>

        </div>
      </div>
    )
}

export default FlowDetail;